import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useTranslation } from 'react-i18next';
import DesktopVersionsList from '../../Components/Customer/DesktopVersionsList';
import Modal from '../../Components/Modal';
import EmailTemplate from '../../Components/EmailTemplate';
import commonActionsImp from "../../Actions/commonActions";
import customerActionsImp from "../../Actions/customerActions";
import { DefaultCard } from "../../Components/Card/Card";

function SendDesktopVersionContainer() {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const licenses = useSelector(state => state.CustomerReducer.desktopLicenses);
    const customer = useSelector(state => state.CustomerReducer.customer);
    const emailForm = useSelector(state => state.CommonReducer.forms?.sendDesktopVersion);
    const commonActions = bindActionCreators(commonActionsImp, dispatch);
    const customerActions = bindActionCreators(customerActionsImp, dispatch);

    useEffect(() => {
        if (customer?.vbCustomer?.customerNumber) {
            customerActions.getDesktopLicenses(customer.vbCustomer.customerNumber);
        }
    }, [customer?.customerNumber]);

    const onOpenFormClick = useCallback(
        (id, version, licenseKey) => {
            customerActions.getSendDesktopLicenseTemplate(
                customer.vbCustomer?.customerNumber,
                id,
                version,
                licenseKey
            );
        },
        [customerActions, customer]
    );

    const onFieldChange = useCallback(
        (field, value) => {
            if (!emailForm) return;
            commonActions.changeMultiFormField(emailForm.id, field, value);
        },
        [commonActions, emailForm]
    );

    const onSendClick = useCallback(() => {
        if (emailForm) {
            customerActions.sendDesktopVersionEmail(emailForm);
        }
    }, [customerActions, emailForm]);

    const onCancelClick = useCallback(() => {
        if (!emailForm) return;
        commonActions.cancelFormEditing(emailForm.id);
        commonActions.showModal(false);
    }, [commonActions, emailForm]);

    if (!licenses) {
        return null;
    }

    const modalProps = {
        component: EmailTemplate,
        title: t('senddesktopversioncontainer.senddesktopversion'),
        mainButtonTitle: t('senddesktopversioncontainer.send'),
        data: emailForm && emailForm.data,
        bodyHeight: 200,
        onChange: onFieldChange,
        onSaveClick: onSendClick,
        onCancelClick: onCancelClick
    };

    return (
        <DefaultCard title={t('senddesktopversioncontainer.header')} hasNoData={licenses.length === 0}>
            <DesktopVersionsList licenses={licenses} onOpenFormClick={onOpenFormClick} />
            <Modal {...modalProps} />
        </DefaultCard>
    );
}

export default SendDesktopVersionContainer;